"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lodash_1 = __importDefault(require("lodash"));
exports.default = (function (props) {
    var _a = react_1.useState(false), focus = _a[0], setFocus = _a[1];
    var focusHandler = function () {
        setFocus(true);
    };
    var blurHandler = function () {
        setFocus(false);
    };
    return (react_1.default.createElement("div", { className: "input flex flex-row " + (props.className || ""), "data-disabled": props.disabled, "data-focus": focus },
        react_1.default.createElement("label", { htmlFor: "ti_" + props.name },
            props.altLabel || lodash_1.default.startCase(props.name.replace(/-/g, " ")),
            ":"),
        react_1.default.createElement("div", { className: 'input__wrapper', "data-name": props.name },
            react_1.default.createElement("input", __assign({}, props, { onFocus: focusHandler, onBlur: blurHandler, id: "ti_" + props.name })))));
});
